

(function () {
    'use strict';

    Controllers.MoveStageModalController = class MoveStageModalController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $translate, Constants, WorkspacesManager, WorkspaceService, $modalInstance,
                    AnalyticsService, EventsManager, PopupMessageService, Enums, workspace, company
        )  {
            super($scope, $injector);
            this.__objectType = 'MoveStageModalController';
            this.WorkspacesManager = WorkspacesManager;
            this.AnalyticsService = AnalyticsService;
            this.WorkspaceService = WorkspaceService;
            this.EventsManager = EventsManager;
            this.PopupMessageService = PopupMessageService;
            this.$modalInstance = $modalInstance;
            this.Enums = Enums;
            this.workspace = workspace;
            this.company = company;
            this.learnMoreLink = "https://help.honeybook.com/en/articles/2209123-understanding-the-project-pipeline";
            this.stageDropdownOptions =  this.prepareStageDropdownOptions();

            // assign selectedStage
            if (this.workspace && this.workspace.active_state) {
                this.selectedStage = this.stageDropdownOptions.find(
                    opt => opt._id === this.workspace
                        .workspace_pipeline_data
                        .current_stage
                        .stage_id
                );
            } else {
                this.selectedStage = null;
            }

        }

        close() {
            this.$modalInstance.dismiss();
        }

        onCtaClick(event) {
            this.isBtnClicked = true;
            // this.props.ctaCallback();
            this.onMoveStage();
            event.stopPropagation();
        }

        onStageChange(item) {
            this.selectedStage = item;
        }

        onMoveStage() {
            this.AnalyticsService.trackClick(
                this,
                "pipeline_view: Move to stage"
            );

            const currentStageId = this.workspace.workspace_pipeline_data.current_stage.stage_id;
            const stageId = this.selectedStage._id;

            if (currentStageId === stageId && this.workspace.active_state) {
                this.$modalInstance.close();
            }

            this.requestInProgress = true;
            const trackingDisabled = this.workspace.workspace_pipeline_data.disable_tracking;

            const trackingData = {
                workspace_id: this.workspace._id,
                moveToStage: stageId
            };

            this.WorkspacesManager.updateWorkspaceStage(
                this.workspace,
                stageId,
                trackingDisabled ? false : null
            ).then(() => {
                this.AnalyticsService.track(
                    this, this.AnalyticsService.analytics_events.workspace_pipeline_move_to_stage + ' Successful pipeline_quick_action',
                    trackingData
                );
                this.EventsManager.getEventsMasterCollection().trigger("workspaceStatusUpdated");
            }).catch((res) => {
                this.AnalyticsService.track(
                    this,
                    this.AnalyticsService.analytics_events.workspace_pipeline_move_to_stage + ' Failed pipeline_quick_action',
                    trackingData
                );

                if (res && res.data && res.data.error_message) {
                    this.PopupMessageService.showAlert(
                        this.PopupMessageService.severityTypes.error,
                        res.data.error_message
                    );
                } else {
                    this.PopupMessageService.showAlert(
                        this.PopupMessageService.severityTypes.error,
                        'ERRORS.SERVER_API._UNKNOWN_'
                    );
                }
            }).finally(() => {
                this.requestInProgress = false;
                this.$modalInstance.close();
            });

        }

        prepareStageDropdownOptions() {
            return this.company.user_pipeline_stages
                .map(stage => {
                    const originalName = stage.originalName || stage.name;

                    return Object.assign({}, stage, {
                        originalName,
                        name: this.WorkspaceService.getPipelineStageName(originalName)
                    });
                })
                .sort(stage => stage.order || 0);
        }
    };

}());
